module.exports = __webpack_public_path__ + "fonts/GT-Pressura-Bold.295bb69.woff";